// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".spinner[data-v-4ca05261]{animation:rotate-4ca05261 3s linear infinite;height:1.6em;width:1.6em}.path[data-v-4ca05261]{stroke-linecap:round;animation:dash-4ca05261 2s ease-in-out infinite}@keyframes rotate-4ca05261{to{transform:rotate(1turn)}}@keyframes dash-4ca05261{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}to{stroke-dasharray:90,150;stroke-dashoffset:-124}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
